@if (this.actionStack!.getValue('elCModeFonctionnement') === 5) {
  <app-larged-tuile
    icon="fa-kit fa-picto-electrolyseur"
    [title]="'P00037.dashboard.electrolyseur' | translate"
    [buttons]="getButtonsMode()"
    [status]="
      buttons[this.actionStack!.getValue('elSEtatProduction')].title | translate
    "
    [statusMode]="
      this.actionStack!.getValue('elSAlarme') === 1
        ? 'alarm'
        : buttons[this.actionStack!.getValue('elSEtatProduction')].status!
    "
    [mode]="
      modes[this.actionStack!.getValue('elCModeFonctionnement')].title
        | translate
    "
    [selectItem]="
      this.actionStack!.getValue('elCModeFonctionnement') === 4
        ? 2
        : this.actionStack!.getValue('elCModeFonctionnement') === 3
          ? 2
          : this.actionStack!.getValue('elCModeFonctionnement')
    "
    (onPressSetting)="this.openProductModal()"
    (onChange)="changeMode($event)"
  >
    <div class="bg-paid-orange p-3" style="border-radius: 10px">
      <div class="color-orange">
        {{ 'P00037.dashboard.electrolyseur.test.titre' | translate }}
      </div>
      <div>
        {{
          brandOverride(
            'P00037.dashboard.electrolyseur.test.description' | translate
          )
        }}
      </div>
    </div>
  </app-larged-tuile>
} @else {
  <app-larged-tuile
    icon="fa-kit fa-picto-electrolyseur"
    [title]="'P00037.dashboard.electrolyseur' | translate"
    [buttons]="getButtonsMode()"
    [status]="
      buttons[this.actionStack!.getValue('elSEtatProduction')].title | translate
    "
    [statusMode]="
      this.actionStack!.getValue('elSAlarme') === 1
        ? 'alarm'
        : buttons[this.actionStack!.getValue('elSEtatProduction')].status!
    "
    [mode]="
      modes[this.actionStack!.getValue('elCModeFonctionnement')].title
        | translate
    "
    [selectItem]="
      this.actionStack!.getValue('elCModeFonctionnement') === 4
        ? 2
        : this.actionStack!.getValue('elCModeFonctionnement') === 3
          ? 2
          : this.actionStack!.getValue('elCModeFonctionnement')
    "
    (onPressSetting)="this.openProductModal()"
    (onChange)="changeMode($event)"
  >
  </app-larged-tuile>
}
